export const TableCellId = {
  FULL_NAME: 'fullName',
  PARTY: 'party',
  E_CONSENT: 'eConsent',
  CREDIT_CONSENT: 'creditConsent',
};

export const tableCellWidthMap = {
  [TableCellId.FULL_NAME]: '25%',
  [TableCellId.PARTY]: '25%',
  [TableCellId.E_CONSENT]: '25%',
  [TableCellId.CREDIT_CONSENT]: '25%',
};

export const EConsentPartyType = {
  PRIMARY_BORROWER: 'PrimaryBorrower',
  CO_BORROWER: 'CoBorrower',
  NON_BORROWER: 'NonBorrower',
};

export const E_CONSENT_PARTY_TYPE_OPTIONS = [
  { name: 'Borrower', value: EConsentPartyType.PRIMARY_BORROWER },
  { name: 'Co-Borrower', value: EConsentPartyType.CO_BORROWER },
  { name: 'NBE', value: EConsentPartyType.NON_BORROWER },
];
